export const themes = {
  thumbnail: {
    thPriceFrom: 'font-sans text-base text-gray-darker px-1',
  },
  compare: {
    thPriceFrom: 'font-sans text-sm md:text-base text-gray-darker px-1',
  },
};
